import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { isAxiosError, LabDataException, LabException } from '../apis/service/exception';
import { HttpServiceHelper } from './utils/HttpServiceHelper';
let LabHttpService = class LabHttpService extends HttpServiceHelper {
    constructor(i18n, httpClient, errorHandlerService) {
        super(errorHandlerService);
        this.i18n = i18n;
        this.httpClient = httpClient;
        this.errorHandlerService = errorHandlerService;
        this.configErrorHandler();
    }
    // #region 全局错误处理相关
    configErrorHandler() {
        this.errorHandlerService.addHandler(error => {
            if (LabDataException.is(error)) {
                const msg = error.data?.data?.error_message || this.i18n.t('loginFail.unknown');
                this._errorDisplayProxy(msg);
                return true;
            }
            if (!LabException.is(error)) {
                return false;
            }
            const labError = error.response?.data;
            if (!labError) {
                return false;
            }
            // todo有的错误由前端翻译处理
            this._errorDisplayProxy(labError.error_message);
            return true;
        });
    }
    // #endregion
    request(config) {
        config = {
            ...config,
            params: {
                ...config?.params,
            },
        };
        return this.httpClient(config).then((res) => {
            const data = res.data;
            if (data?.status === false) {
                throw LabDataException.mark(res);
            }
            return data;
        }, error => {
            if (!isAxiosError(error)) {
                throw error;
            }
            error = LabException.mark(error);
            throw error;
        });
    }
};
LabHttpService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.HttpClient)),
    __param(2, inject(Symbols.ErrorHandlerService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], LabHttpService);
export { LabHttpService };
